module.exports = __webpack_public_path__ + "img/Planet.ea57f236.svg";